<span class="ap-skeleton__button" aria-live="polite" aria-busy="true"></span>
